<template>
  <div>
    <Admin_profile/>
  </div>
</template>

<script>
import Admin_profile from "@/components/adminArin/admin_overall/Admin_profile";
export default {
  name: "AdminProfile",
  components: {
    Admin_profile
  }
}
</script>

<style scoped>

</style>
